import { render, staticRenderFns } from "./importFromView.vue?vue&type=template&id=0019f3c1&scoped=true"
import script from "./importFromView.vue?vue&type=script&lang=js"
export * from "./importFromView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0019f3c1",
  null
  
)

export default component.exports